@if (textBlockData.text || textBlockData.buttons.length) {
  <div
    class="px-8 bg-cover"
    [ngStyle]="{
      'background-image': backgroundImageUrl
        ? 'url(' + backgroundImageUrl + ')'
        : '',
    }"
    [ngClass]="{
      'pt-16 md:pt-24': textBlockData.topPadding,
      'pt-6': !textBlockData.topPadding,
      'pb-16 md:pb-24': textBlockData.bottomPadding,
      'bg-black': textBlockData.backgroundColor === 'black',
      'bg-white': textBlockData.backgroundColor === 'white',
      'md:px-32 lg:px-44 xl:px-56':
        textBlockData.contentAlignment === 'center' &&
        !textBlockData.extraXPadding,
      'md:px-32':
        textBlockData.contentAlignment !== 'center' &&
        !textBlockData.extraXPadding,
      'md:px-40 lg:px-52 xl:px-72 ssxl:px-80': textBlockData.extraXPadding,
    }"
  >
    <div
      class="flex w-full"
      [ngClass]="{
        'md:justify-center': textBlockData.contentAlignment === 'center',
        'md:justify-start': textBlockData.contentAlignment === 'left',
        'md:justify-end': textBlockData.contentAlignment === 'right',
      }"
    >
      <div
        class="w-full"
        [ngClass]="{ 'md:basis-2/3': textBlockData.halfSized }"
      >
        <div
          class="pb-6"
          [innerHTML]="textBlockData.text | safe: 'html'"
          [ssDirectus]="{
            collection: 'textBlock',
            item: textBlockData.id,
            fields: ['text'],
          }"
          [ngClass]="{
            'text-center': textBlockData.contentAlignment === 'center',
            'text-left': textBlockData.contentAlignment === 'left',
            'text-right': textBlockData.contentAlignment === 'right',
            'text-ss-brown': textBlockData.backgroundColor === 'white',
          }"
        ></div>
        <div
          class="flex flex-col md:flex-row gap-4 md:gap-5"
          [ngClass]="{
            'md:justify-center': textBlockData.contentAlignment === 'center',
            'md:justify-start': textBlockData.contentAlignment === 'left',
            'md:justify-end': textBlockData.contentAlignment === 'right',
          }"
        >
          @for (
            button of textBlockData.buttons;
            track trackButtons($index, button)
          ) {
            <ss-building-block-button-link
              [buttonLink]="button.item"
            ></ss-building-block-button-link>
          }
        </div>
      </div>
    </div>
    @if (textBlockData.extraBottomPad) {
      <div class="h-36 md:h-44"></div>
    }
  </div>
}
<div class="md:mx-28"></div>
